/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';

export function getCodeBlocks(feature: BaseFeature): CodeBlock[] {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;

    const links = project.getNodeLinks(feature as BaseNode, 'sys.reboot');

    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            template: 'machine.reset()',
            id: link.getID(),
        });
    }


    return blocks;
}
